import { axiosInstance } from '../utils/axios';
import SecureStorage from '../utils/secureStorage';

export const getCustomerTickets = async () => {
    const token = SecureStorage.getCustomerToken();
    if (!token) {
        throw new Error('Customer not authenticated - please sign in again');
    }
    
    try {
        const response = await axiosInstance.get('/auth/customer/tickets', {
            headers: {
                Authorization: token
            }
        });
        return response;
    } catch (error: any) {
        // If token is invalid, clean it up
        if (error.response?.status === 401) {
            SecureStorage.removeCustomerToken();
            throw new Error('Session expired - please sign in again');
        }
        throw error;
    }
};